// extracted by mini-css-extract-plugin
module.exports = {"claimBanner":"ClaimBanner_claimBanner__4yk7L","claimLink":"ClaimBanner_claimLink__v4gIc","claim":"ClaimBanner_claim__nrcr2","subClaim":"ClaimBanner_subClaim__WknX0"};